// third-party
import { createSlice } from '@reduxjs/toolkit';

// project import
import CountryDto from 'common/dto-types/country-dto';

type CountrySliceStates = {
    data?: CountryDto;
    isFormOpen: boolean;
    updates: number;
    isSyncFdcpCountriesFormOpen: boolean;
};

const initialState: CountrySliceStates = {
    isFormOpen: false,
    updates: 0,
    isSyncFdcpCountriesFormOpen: false,
};

const country = createSlice({
    name: 'country',
    initialState,
    reducers: {
        openCreateForm(state) {
            state.isFormOpen = true;
            state.updates += 1;
        },

        closeForm(state) {
            state.data = undefined;
            state.isFormOpen = false;
            state.updates += 1;
        },

        openSyncFdcpCountriesForm(state) {
            state.isSyncFdcpCountriesFormOpen = true;
        },

        closeSyncFdcpCountriesForm(state) {
            state.isSyncFdcpCountriesFormOpen = false;
        },
    },
});

export default country.reducer;

export const { openCreateForm, closeForm, openSyncFdcpCountriesForm, closeSyncFdcpCountriesForm } = country.actions;
